import * as HTTP from './http';

// region CreateTracing
export const CreateTracing = async(payload) => {
    let endpoint = `candid/create/tracing`;

    const body = {...payload};
    try{
        var result = await HTTP.POST(endpoint, body);
    }catch(e){
        console.log(`CONTROLLER ERROR: Candid.CreateTracing\n${e}`);
        return undefined;
    }

    return result;
}

// region GetTracingReport
export const GetTracingReport = async() => {
    let endpoint = `candid/tracing/report`;

    try{
        var result = await HTTP.GET(endpoint);
    }catch(e){
        console.log(`CONTROLLER ERROR: Candid.GetTracingReport\n${e}`);
        return undefined;
    }

    return result;
}

// region GetHistory
export const GetHistory = async(id) => {
    let endpoint = `candid/history/${encodeURIComponent(id)}`;

    try{
        var result = await HTTP.GET(endpoint);
    }catch(e){
        console.log(`CONTROLLER ERROR: Candid.GetHistory\n${e}`);
        return undefined;
    }

    return result;
}

// region GetTracingReportByOrder
export const GetTracingReportByOrder = async(order) => {
    let endpoint = `candid/tracing/report/order/${encodeURIComponent(order)}`;

    try{
        var result = await HTTP.GET(endpoint);
    }catch(e){
        console.log(`CONTROLLER ERROR: Candid.GetTracingReportByOrder\n${e}`);
        return undefined;
    }

    return result;
}